'use client';

import styles from './InputCheckbox.module.scss';

export type InputCheckboxProps = {
  name: string;
  inputValue: string;
  checked?: boolean;
  onChange: (e: React.ChangeEvent) => void;
  children?: React.ReactNode;
  inputRef?: React.Ref<HTMLInputElement>;
  spacing?: 'narrow' | 'normal' | 'wide';
};

function InputCheckbox({
  name,
  inputValue,
  checked = false,
  onChange,
  inputRef,
  children,
  spacing = 'normal',
}: InputCheckboxProps) {
  // spacingクラス名を生成
  const spacingClass =
    spacing !== 'normal' ? styles[`spacing${spacing.charAt(0).toUpperCase() + spacing.slice(1)}`] : '';

  return (
    <label key={inputValue} className={`${styles.inputCheckbox} ${spacingClass}`}>
      <input
        type='checkbox'
        name={name}
        ref={inputRef}
        value={inputValue}
        checked={checked}
        onChange={(e) => onChange(e)}
        className={checked ? styles.manualChecked : ''}
      />
      <span className={styles.span}>{children}</span>
    </label>
  );
}

export default InputCheckbox;
